import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/core'
import { Theme } from '../MUI'
import { CertificatePageLayoutProps } from "./CertificatePage/CertificatePageLayout";
import { CertificatePageLayout } from './CertificatePage'

const renderEmbedCertificateCheckPage = (data: CertificatePageLayoutProps) => {
  return (
    <BrowserRouter>
        <ThemeProvider theme={Theme}>
          <CertificatePageLayout {...data} />
        </ThemeProvider>
    </BrowserRouter>
  );
}

export default renderEmbedCertificateCheckPage;